module.exports = __webpack_public_path__ + "static/media/R-PANELv6.5-RC1/onboarding-reputación-CM.c4e509cb.mp4";